import React from 'react';
import { styled } from 'themes';
import { /* Img, */ LinkTexting } from 'components';
import Badges from 'components/badges';
import { device } from 'themes/media-queries';
import { useTranslation } from 'react-i18next';

type Props = {
  hideTitle?: boolean;
};

const DownloadApp = (props: Props) => {
  const { hideTitle } = props;
  const [t] = useTranslation();

  return (
    <Section>
      <Content>
        {!hideTitle && <Title>{t('download-app.heading')}</Title>}
        <Subtitle>{t('download-app.subheading')}</Subtitle>
        <LinkTexting />
        <DownloadBadges />
      </Content>
      {/* <Image fluid={data.image.fluid} /> */}
    </Section>
  );
};

const Section = styled.section`
  grid-column: center-start / center-end;
  margin-top: 0rem;
  margin-bottom: 0rem;

  display: grid;
  grid-template-columns: 1fr;
  grid-auto-rows: 1fr;

  @media ${device.tablet} {
    grid-template-columns: 1fr;
  }
`;

const Content = styled.div`
  @media ${device.tablet} {
    margin-bottom: 3rem;
  }
`;

const Title = styled.h2`
  margin-bottom: 3px;
`;

const Subtitle = styled.p`
  font-size: 2.2rem;
  margin-bottom: 2rem;
`;

const DownloadBadges = styled(Badges)`
  margin-top: 3rem;
`;

export default DownloadApp;
